/**
 * Modal de geração do Relatório de Controle de Caixas de Picking.
 * Permite selecionar o formato (PDF / CSV) e aplicar filtros.
 */
export default {
	html: `
		<form id="picking-boxes-report-form" class="form" autocomplete="off">
			<p class="fss">Gera o relatório de caixas de picking com os filtros selecionados abaixo.</p>

			<div class="fsb mtm">
				<label>Formato
					<select id="pkbox-rpt-format">
						<option value="pdf">PDF</option>
						<option value="csv">CSV (separador ;)</option>
					</select>
				</label>
			</div>

			<hr style="margin:1rem 0 0.75rem">
			<p class="fss" style="margin:0 0 0.5rem 0"><strong>Filtros</strong> (todos opcionais)</p>

			<div style="display:grid;grid-template-columns:1fr 1fr;gap:0.5rem 1rem;">
				<label class="fss">Nº Caixa
					<input type="text" id="pkbox-rpt-code" maxlength="60" placeholder="parcial ou completo">
				</label>
				<label class="fss">Nº Lacre
					<input type="text" id="pkbox-rpt-seal" maxlength="60" placeholder="parcial ou completo">
				</label>
				<label class="fss">Nº Saída
					<input type="number" id="pkbox-rpt-output" min="1" step="1" placeholder="ID da saída">
				</label>
				<label class="fss">Status
					<select id="pkbox-rpt-status">
						<option value="">Todos</option>
						<option value="10">Aberta</option>
						<option value="20">Lacrada</option>
						<option value="30">Cancelada</option>
					</select>
				</label>
				<label class="fss">Abertura — de
					<input type="date" id="pkbox-rpt-from">
				</label>
				<label class="fss">Abertura — até
					<input type="date" id="pkbox-rpt-to">
				</label>
			</div>

			<div class="fsb mtm">
				<button type="button" class="bn_Escape button">Cancelar</button>
				<button type="submit" class="bn_Enter button">Gerar</button>
			</div>
		</form>
	`,
	form: {
		selector: '#picking-boxes-report-form',
	},
	fields: [
		{ properties: { selector: '#pkbox-rpt-format' }, types: [] },
		{ properties: { selector: '#pkbox-rpt-code'   }, types: [] },
		{ properties: { selector: '#pkbox-rpt-seal'   }, types: [] },
		{ properties: { selector: '#pkbox-rpt-output' }, types: [] },
		{ properties: { selector: '#pkbox-rpt-status' }, types: [] },
		{ properties: { selector: '#pkbox-rpt-from'   }, types: [] },
		{ properties: { selector: '#pkbox-rpt-to'     }, types: [] },
	],
};
